var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_upload",
    "data-name": "Iconly/Bold / upload",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M14.25,16H0V9.008a.75.75,0,0,1,1.5,0v5.444h12V9.008a.75.75,0,0,1,1.5,0V16ZM6.75,9.314V5.42H3.9A.551.551,0,0,1,3.441,5.2a.365.365,0,0,1,.014-.437L6.95.2a.591.591,0,0,1,.887,0l3.495,4.559a.366.366,0,0,1,.014.437.55.55,0,0,1-.458.223H8.25V9.314a.75.75,0,1,1-1.5,0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Combined_Shape_Color_Mask",
    "data-name": "Combined Shape + Color Mask",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M14.25,16H0V9.008a.75.75,0,0,1,1.5,0v5.444h12V9.008a.75.75,0,0,1,1.5,0V16ZM6.75,9.314V5.42H3.9A.551.551,0,0,1,3.441,5.2a.365.365,0,0,1,.014-.437L6.95.2a.591.591,0,0,1,.887,0l3.495,4.559a.366.366,0,0,1,.014.437.55.55,0,0,1-.458.223H8.25V9.314a.75.75,0,1,1-1.5,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-2",
    "data-name": "Color",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-3",
    "data-name": "Color",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "color_borders",
    "data-name": "color/borders",
    width: 19,
    height: 19,
    rx: 4,
    fill: "#c4cdd5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.610ddafa2ff4931ad5654d26d4fb257b.svg";
export { ForwardRef as ReactComponent };